export default __webpack_public_path__ + "images/e80d187fc29700ce0f786f67691d788e-beer_small.webp";